import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "reactstrap";
import { DragItem } from "./DragItem";
import { DropItem } from "./DropItem";
import { AxiosError } from "axios";
import { OwnershipInformationdata } from "../OwnershipForm/Ownershipinfomationdata";
import userIconWarn from '../../../../images/red-warn.svg'
import Service from "../../../../services";
import { catchError } from "../../../../utils/Utils";


interface OwnersListProps {
    individualsData: OwnershipInformationdata[];
    getIndividuals: () => void;
    clientStockData: any;
    postSaveStockSymbol: (yesOrNo?: string) => void;
    getAllOwnershipContacts: () => void;
    disableFields: boolean | undefined;
}


const OwnersList = (props: OwnersListProps) => {
    const { individualsData } = props;
    const [ownersData, setOwnersData] = useState<OwnershipInformationdata[]>(
        []
    );
    const [load, setLoad] = useState(true)
    const [isDragable, setIsDragable] = useState<boolean>(false);
    const [panelDragData, setPanelDragData] = useState<any>([[]]);
    const [validateIndex, setValidateIndex] = useState<number[]>([]);
    const [editMode, setEditMode] = useState<boolean>(true);
    const service = new Service();

    const getListed = (data?: OwnershipInformationdata[]) => {
        const result: [] =
            data?.reduce((accumulator: any, currentValue: any) => {
                const accValues = accumulator?.some((each: any) =>
                    each?.some((each2: any) => each2?.groupId === currentValue?.groupId))
                if (!accValues && currentValue?.groupId) {
                    const stages = data?.filter((each: any) => each?.groupId === currentValue?.groupId);
                    return [...accumulator, stages]
                } else {
                    return accumulator
                }
                // return accumulator
            }, []);
        return result;
    }


    useEffect(() => {
        const toDataLength = Math.ceil((ownersData.length / 2));
        const newDraggedList = Array.from({ length: toDataLength }, () =>
            []);
        // eslint-disable-next-line @typescript-eslint/no-shadow
        const results = ownersData.reduce(function (results: any, org: any) {
            (results[org?.groupId] = results[org?.groupId] || []).push(org);
            return results;
        }, {})
        const prvList: any = (getListed(ownersData))
        setPanelDragData(prvList.concat(newDraggedList))
        setTimeout(() => {
            setLoad(false)
        }, 1000)
    }, [load, ownersData.length])

    const saveData = () => {
        // remove all properties from the dragged list and need to send only owner id
        const newDraggedList = panelDragData.map((item: any) => {
            return item.map((owner: any) => ({
                groupcode: owner?.groupcode,
                grouped: owner?.grouped,
                individualId: owner?.individualId,
                ownerId: owner?.ownerId
            }));
        });

        const newList = newDraggedList.filter((ele: any) => (ele.length > 0))
        const errorIndexList = newDraggedList.map((ele: any, index: number) => {
            if (ele.length === 1) {
                return index
            }
            else {
                return
            }
        })
        const validate = errorIndexList.find((el: any) => el > -1)
        if (validate !== undefined) {
            setValidateIndex(errorIndexList)
        }
        else {
            setEditMode(true)
            setValidateIndex([])
            service.saveOrUpdateGroupofIndividuals(newList).then(() => {
                props?.getIndividuals()
                props?.getAllOwnershipContacts();
            }).catch((error: any) => {
                catchError(error, true);
            })
        }
    }

    const setEdit = () => {
        setEditMode(!editMode)
        props?.getIndividuals()
        props?.getAllOwnershipContacts();

    }

    const setDragClass = () => {
        if (editMode) {
            return "ownersListBoxIdle"
        }
        else if (isDragable) {
            return "ownersListBox"
        }
        else {
            return "ownersListBoxIdle"
        }
    }

    useEffect(() => {
        if (individualsData && individualsData.length > 0) {
            setOwnersData(individualsData);
        }
    }, [individualsData])

    const duplicateIndividuals = (value?: string) => {
        setEditMode(false)
        props?.postSaveStockSymbol(value);
        // eslint-disable-next-line @typescript-eslint/no-shadow            
        setPanelDragData(panelDragData.map((pd: any) => {
            pd = [];
            return pd;
        }))

        props.getIndividuals();

    }// yes/no

    useEffect(() => {
        if (props?.clientStockData?.duplicateIndividuals === 'no' ||
            props?.clientStockData?.duplicateIndividuals === null) {
            setIsDragable(false)
        } else {
            setIsDragable(true)
        }

    }, [props?.clientStockData?.duplicateIndividuals])
    return (
        <>
            <div className="ownersListContainer">
                <h6>Are there any duplicate individuals listed above? <h6 className="input-required">*</h6></h6>
                <div className="yesOrNoWrap">
                    <Button className={`yesOrNo ${(props?.clientStockData?.duplicateIndividuals == 'no' ||
                        props?.clientStockData?.duplicateIndividuals == null) && 'unSelect'} `}
                        onClick={() => duplicateIndividuals('yes')} disabled={props.disableFields}>Yes</Button>
                    <Button className={`yesOrNo ${(props?.clientStockData?.duplicateIndividuals == 'yes' ||
                        props?.clientStockData?.duplicateIndividuals == null) && 'unSelect'} `}
                        onClick={() => duplicateIndividuals('no')} disabled={props.disableFields}>No</Button>
                </div>
                <Row>
                    {props.clientStockData?.duplicateIndividuals == 'yes'
                        ? <p className="DragHeading">Please drag and drop duplicate
                            individuals to group them as a single individual</p> : " "}
                </Row>
                <Row className="dragableContainer">
                    {props?.clientStockData?.duplicateIndividuals == null ? " " : <Col md="3">
                        <div className={setDragClass()}>
                            {ownersData?.map((item: OwnershipInformationdata) => (
                                <DragItem item={item} key={item.ownerId} disableFields={props.disableFields} />
                            ))}
                        </div>
                    </Col>}
                    {isDragable &&
                        <Col >
                            <div className="draggedBoxDiv">
                                <div className="ownersItemBox" >
                                    <div className="draggedRowsDiv">
                                        {panelDragData?.map((el: [], index: number) => (
                                            <React.Fragment key={index} >
                                                <DropItem el={el}
                                                    index={index}
                                                    validateIndex={validateIndex}
                                                    ownersData={ownersData}
                                                    setOwnersData={setOwnersData}
                                                    panelDragData={panelDragData}
                                                    setPanelDragData={setPanelDragData}
                                                    setValidateIndex={setValidateIndex}
                                                    editMode={editMode}
                                                    getAllOwnershipContacts={props?.getAllOwnershipContacts}
                                                    getIndividuals={props?.getIndividuals}
                                                    setLoad={setLoad}
                                                    disableFields={props.disableFields}
                                                />
                                            </React.Fragment>

                                        ))}
                                    </div>
                                </div>
                                <div className="btnsDiv">
                                    {!editMode ? <><button className="doneButton" onClick={saveData}
                                        //disabled={!panelDragData.some((el:any)=>el.length>0)}
                                        disabled={props.disableFields}>Done</button>
                                        {/* <span onClick={()=>setIsDragable(!isDragable)}
                                             className="cancelBtn">Cancel</span> */}
                                    </>
                                        : <button onClick={setEdit}
                                            className="editButton" disabled={props.disableFields}>Edit</button>}

                                </div>
                            </div>
                            {validateIndex?.length > 0 && <div className="ownerSelectError">
                                <img src={userIconWarn} /> Must be more than one individual per line
                            </div>}
                        </Col>}
                </Row>
            </div>
        </>
    )
}

export default OwnersList;



